/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PerfilRouteRouteImport } from './routes/$perfil/route'
import { Route as ChamadoRouteImport } from './routes/chamado'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as PerfilIndexRouteImport } from './routes/$perfil/index'
import { Route as PerfilAdesaoFrangoRouteImport } from './routes/$perfil/adesao-frango'
import { Route as PerfilAlertasRouteImport } from './routes/$perfil/alertas'
import { Route as PerfilConfiguracoesRouteImport } from './routes/$perfil/configuracoes'
import { Route as PerfilEntregasRouteImport } from './routes/$perfil/entregas'
import { Route as PerfilErrosRouteImport } from './routes/$perfil/erros'
import { Route as PerfilInicioRouteImport } from './routes/$perfil/inicio'
import { Route as PerfilPessoasRouteImport } from './routes/$perfil/pessoas'
import { Route as PerfilQualidadeRouteImport } from './routes/$perfil/qualidade'
import { Route as PerfilTarefasParadasRouteImport } from './routes/$perfil/tarefas-paradas'
import { Route as PerfilUsoIaRouteImport } from './routes/$perfil/uso-ia'
import { Route as PerfilVisaoGeralRouteImport } from './routes/$perfil/visao-geral'
import { Route as DevComponentesRouteImport } from './routes/dev/componentes'
import { Route as DevTokensRouteImport } from './routes/dev/tokens'
import { Route as LegadoSplatRouteImport } from './routes/legado/$'
import { Route as PerfilFrangoIndexRouteImport } from './routes/$perfil/frango/index'
import { Route as PerfilMergeguardIndexRouteImport } from './routes/$perfil/mergeguard/index'
import { Route as PerfilMergeguardConfigHashRouteImport } from './routes/$perfil/mergeguard/$configHash'
import { Route as PerfilMeusAlertasIndexRouteImport } from './routes/$perfil/meus-alertas/index'
import { Route as PerfilMeusAlertasAlertaIdRouteImport } from './routes/$perfil/meus-alertas/$alertaId'
import { Route as PerfilProjetosIndexRouteImport } from './routes/$perfil/projetos/index'
import { Route as PerfilProjetosProjetoIdRouteImport } from './routes/$perfil/projetos/$projetoId'
import { Route as PerfilRegrasIndexRouteImport } from './routes/$perfil/regras/index'
import { Route as PerfilRegrasCodigoRouteImport } from './routes/$perfil/regras/$codigo'
import { Route as PerfilTimesIndexRouteImport } from './routes/$perfil/times/index'
import { Route as PerfilTimesTimeIdRouteImport } from './routes/$perfil/times/$timeId'
import { Route as PerfilFrangoProjetoIidRouteImport } from './routes/$perfil/frango/$projeto.$iid'
import { Route as PerfilFrangoLoteProjetoIidRouteImport } from './routes/$perfil/frango/lote.$projeto.$iid'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilRouteRoute = PerfilRouteRouteImport.update({
  id: '/$perfil',
  path: '/$perfil',
  getParentRoute: () => rootRouteImport,
} as any)
const ChamadoRoute = ChamadoRouteImport.update({
  id: '/chamado',
  path: '/chamado',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilIndexRoute = PerfilIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilAdesaoFrangoRoute = PerfilAdesaoFrangoRouteImport.update({
  id: '/adesao-frango',
  path: '/adesao-frango',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilAlertasRoute = PerfilAlertasRouteImport.update({
  id: '/alertas',
  path: '/alertas',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilConfiguracoesRoute = PerfilConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilEntregasRoute = PerfilEntregasRouteImport.update({
  id: '/entregas',
  path: '/entregas',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilErrosRoute = PerfilErrosRouteImport.update({
  id: '/erros',
  path: '/erros',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilInicioRoute = PerfilInicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilPessoasRoute = PerfilPessoasRouteImport.update({
  id: '/pessoas',
  path: '/pessoas',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilQualidadeRoute = PerfilQualidadeRouteImport.update({
  id: '/qualidade',
  path: '/qualidade',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilTarefasParadasRoute = PerfilTarefasParadasRouteImport.update({
  id: '/tarefas-paradas',
  path: '/tarefas-paradas',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilUsoIaRoute = PerfilUsoIaRouteImport.update({
  id: '/uso-ia',
  path: '/uso-ia',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilVisaoGeralRoute = PerfilVisaoGeralRouteImport.update({
  id: '/visao-geral',
  path: '/visao-geral',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const DevComponentesRoute = DevComponentesRouteImport.update({
  id: '/dev/componentes',
  path: '/dev/componentes',
  getParentRoute: () => rootRouteImport,
} as any)
const DevTokensRoute = DevTokensRouteImport.update({
  id: '/dev/tokens',
  path: '/dev/tokens',
  getParentRoute: () => rootRouteImport,
} as any)
const LegadoSplatRoute = LegadoSplatRouteImport.update({
  id: '/legado/$',
  path: '/legado/$',
  getParentRoute: () => rootRouteImport,
} as any)
const PerfilFrangoIndexRoute = PerfilFrangoIndexRouteImport.update({
  id: '/frango/',
  path: '/frango/',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilMergeguardIndexRoute = PerfilMergeguardIndexRouteImport.update({
  id: '/mergeguard/',
  path: '/mergeguard/',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilMergeguardConfigHashRoute =
  PerfilMergeguardConfigHashRouteImport.update({
    id: '/mergeguard/$configHash',
    path: '/mergeguard/$configHash',
    getParentRoute: () => PerfilRouteRoute,
  } as any)
const PerfilMeusAlertasIndexRoute = PerfilMeusAlertasIndexRouteImport.update({
  id: '/meus-alertas/',
  path: '/meus-alertas/',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilMeusAlertasAlertaIdRoute =
  PerfilMeusAlertasAlertaIdRouteImport.update({
    id: '/meus-alertas/$alertaId',
    path: '/meus-alertas/$alertaId',
    getParentRoute: () => PerfilRouteRoute,
  } as any)
const PerfilProjetosIndexRoute = PerfilProjetosIndexRouteImport.update({
  id: '/projetos/',
  path: '/projetos/',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilProjetosProjetoIdRoute = PerfilProjetosProjetoIdRouteImport.update({
  id: '/projetos/$projetoId',
  path: '/projetos/$projetoId',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilRegrasIndexRoute = PerfilRegrasIndexRouteImport.update({
  id: '/regras/',
  path: '/regras/',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilRegrasCodigoRoute = PerfilRegrasCodigoRouteImport.update({
  id: '/regras/$codigo',
  path: '/regras/$codigo',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilTimesIndexRoute = PerfilTimesIndexRouteImport.update({
  id: '/times/',
  path: '/times/',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilTimesTimeIdRoute = PerfilTimesTimeIdRouteImport.update({
  id: '/times/$timeId',
  path: '/times/$timeId',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilFrangoProjetoIidRoute = PerfilFrangoProjetoIidRouteImport.update({
  id: '/frango/$projeto/$iid',
  path: '/frango/$projeto/$iid',
  getParentRoute: () => PerfilRouteRoute,
} as any)
const PerfilFrangoLoteProjetoIidRoute =
  PerfilFrangoLoteProjetoIidRouteImport.update({
    id: '/frango/lote/$projeto/$iid',
    path: '/frango/lote/$projeto/$iid',
    getParentRoute: () => PerfilRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$perfil': typeof PerfilRouteRouteWithChildren
  '/chamado': typeof ChamadoRoute
  '/entrar': typeof EntrarRoute
  '/$perfil/adesao-frango': typeof PerfilAdesaoFrangoRoute
  '/$perfil/alertas': typeof PerfilAlertasRoute
  '/$perfil/configuracoes': typeof PerfilConfiguracoesRoute
  '/$perfil/entregas': typeof PerfilEntregasRoute
  '/$perfil/erros': typeof PerfilErrosRoute
  '/$perfil/inicio': typeof PerfilInicioRoute
  '/$perfil/pessoas': typeof PerfilPessoasRoute
  '/$perfil/qualidade': typeof PerfilQualidadeRoute
  '/$perfil/tarefas-paradas': typeof PerfilTarefasParadasRoute
  '/$perfil/uso-ia': typeof PerfilUsoIaRoute
  '/$perfil/visao-geral': typeof PerfilVisaoGeralRoute
  '/dev/componentes': typeof DevComponentesRoute
  '/dev/tokens': typeof DevTokensRoute
  '/legado/$': typeof LegadoSplatRoute
  '/$perfil/': typeof PerfilIndexRoute
  '/$perfil/mergeguard/$configHash': typeof PerfilMergeguardConfigHashRoute
  '/$perfil/meus-alertas/$alertaId': typeof PerfilMeusAlertasAlertaIdRoute
  '/$perfil/projetos/$projetoId': typeof PerfilProjetosProjetoIdRoute
  '/$perfil/regras/$codigo': typeof PerfilRegrasCodigoRoute
  '/$perfil/times/$timeId': typeof PerfilTimesTimeIdRoute
  '/$perfil/frango/': typeof PerfilFrangoIndexRoute
  '/$perfil/mergeguard/': typeof PerfilMergeguardIndexRoute
  '/$perfil/meus-alertas/': typeof PerfilMeusAlertasIndexRoute
  '/$perfil/projetos/': typeof PerfilProjetosIndexRoute
  '/$perfil/regras/': typeof PerfilRegrasIndexRoute
  '/$perfil/times/': typeof PerfilTimesIndexRoute
  '/$perfil/frango/$projeto/$iid': typeof PerfilFrangoProjetoIidRoute
  '/$perfil/frango/lote/$projeto/$iid': typeof PerfilFrangoLoteProjetoIidRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/chamado': typeof ChamadoRoute
  '/entrar': typeof EntrarRoute
  '/$perfil/adesao-frango': typeof PerfilAdesaoFrangoRoute
  '/$perfil/alertas': typeof PerfilAlertasRoute
  '/$perfil/configuracoes': typeof PerfilConfiguracoesRoute
  '/$perfil/entregas': typeof PerfilEntregasRoute
  '/$perfil/erros': typeof PerfilErrosRoute
  '/$perfil/inicio': typeof PerfilInicioRoute
  '/$perfil/pessoas': typeof PerfilPessoasRoute
  '/$perfil/qualidade': typeof PerfilQualidadeRoute
  '/$perfil/tarefas-paradas': typeof PerfilTarefasParadasRoute
  '/$perfil/uso-ia': typeof PerfilUsoIaRoute
  '/$perfil/visao-geral': typeof PerfilVisaoGeralRoute
  '/dev/componentes': typeof DevComponentesRoute
  '/dev/tokens': typeof DevTokensRoute
  '/legado/$': typeof LegadoSplatRoute
  '/$perfil': typeof PerfilIndexRoute
  '/$perfil/mergeguard/$configHash': typeof PerfilMergeguardConfigHashRoute
  '/$perfil/meus-alertas/$alertaId': typeof PerfilMeusAlertasAlertaIdRoute
  '/$perfil/projetos/$projetoId': typeof PerfilProjetosProjetoIdRoute
  '/$perfil/regras/$codigo': typeof PerfilRegrasCodigoRoute
  '/$perfil/times/$timeId': typeof PerfilTimesTimeIdRoute
  '/$perfil/frango': typeof PerfilFrangoIndexRoute
  '/$perfil/mergeguard': typeof PerfilMergeguardIndexRoute
  '/$perfil/meus-alertas': typeof PerfilMeusAlertasIndexRoute
  '/$perfil/projetos': typeof PerfilProjetosIndexRoute
  '/$perfil/regras': typeof PerfilRegrasIndexRoute
  '/$perfil/times': typeof PerfilTimesIndexRoute
  '/$perfil/frango/$projeto/$iid': typeof PerfilFrangoProjetoIidRoute
  '/$perfil/frango/lote/$projeto/$iid': typeof PerfilFrangoLoteProjetoIidRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$perfil': typeof PerfilRouteRouteWithChildren
  '/chamado': typeof ChamadoRoute
  '/entrar': typeof EntrarRoute
  '/$perfil/adesao-frango': typeof PerfilAdesaoFrangoRoute
  '/$perfil/alertas': typeof PerfilAlertasRoute
  '/$perfil/configuracoes': typeof PerfilConfiguracoesRoute
  '/$perfil/entregas': typeof PerfilEntregasRoute
  '/$perfil/erros': typeof PerfilErrosRoute
  '/$perfil/inicio': typeof PerfilInicioRoute
  '/$perfil/pessoas': typeof PerfilPessoasRoute
  '/$perfil/qualidade': typeof PerfilQualidadeRoute
  '/$perfil/tarefas-paradas': typeof PerfilTarefasParadasRoute
  '/$perfil/uso-ia': typeof PerfilUsoIaRoute
  '/$perfil/visao-geral': typeof PerfilVisaoGeralRoute
  '/dev/componentes': typeof DevComponentesRoute
  '/dev/tokens': typeof DevTokensRoute
  '/legado/$': typeof LegadoSplatRoute
  '/$perfil/': typeof PerfilIndexRoute
  '/$perfil/mergeguard/$configHash': typeof PerfilMergeguardConfigHashRoute
  '/$perfil/meus-alertas/$alertaId': typeof PerfilMeusAlertasAlertaIdRoute
  '/$perfil/projetos/$projetoId': typeof PerfilProjetosProjetoIdRoute
  '/$perfil/regras/$codigo': typeof PerfilRegrasCodigoRoute
  '/$perfil/times/$timeId': typeof PerfilTimesTimeIdRoute
  '/$perfil/frango/': typeof PerfilFrangoIndexRoute
  '/$perfil/mergeguard/': typeof PerfilMergeguardIndexRoute
  '/$perfil/meus-alertas/': typeof PerfilMeusAlertasIndexRoute
  '/$perfil/projetos/': typeof PerfilProjetosIndexRoute
  '/$perfil/regras/': typeof PerfilRegrasIndexRoute
  '/$perfil/times/': typeof PerfilTimesIndexRoute
  '/$perfil/frango/$projeto/$iid': typeof PerfilFrangoProjetoIidRoute
  '/$perfil/frango/lote/$projeto/$iid': typeof PerfilFrangoLoteProjetoIidRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$perfil'
    | '/chamado'
    | '/entrar'
    | '/$perfil/adesao-frango'
    | '/$perfil/alertas'
    | '/$perfil/configuracoes'
    | '/$perfil/entregas'
    | '/$perfil/erros'
    | '/$perfil/inicio'
    | '/$perfil/pessoas'
    | '/$perfil/qualidade'
    | '/$perfil/tarefas-paradas'
    | '/$perfil/uso-ia'
    | '/$perfil/visao-geral'
    | '/dev/componentes'
    | '/dev/tokens'
    | '/legado/$'
    | '/$perfil/'
    | '/$perfil/mergeguard/$configHash'
    | '/$perfil/meus-alertas/$alertaId'
    | '/$perfil/projetos/$projetoId'
    | '/$perfil/regras/$codigo'
    | '/$perfil/times/$timeId'
    | '/$perfil/frango/'
    | '/$perfil/mergeguard/'
    | '/$perfil/meus-alertas/'
    | '/$perfil/projetos/'
    | '/$perfil/regras/'
    | '/$perfil/times/'
    | '/$perfil/frango/$projeto/$iid'
    | '/$perfil/frango/lote/$projeto/$iid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chamado'
    | '/entrar'
    | '/$perfil/adesao-frango'
    | '/$perfil/alertas'
    | '/$perfil/configuracoes'
    | '/$perfil/entregas'
    | '/$perfil/erros'
    | '/$perfil/inicio'
    | '/$perfil/pessoas'
    | '/$perfil/qualidade'
    | '/$perfil/tarefas-paradas'
    | '/$perfil/uso-ia'
    | '/$perfil/visao-geral'
    | '/dev/componentes'
    | '/dev/tokens'
    | '/legado/$'
    | '/$perfil'
    | '/$perfil/mergeguard/$configHash'
    | '/$perfil/meus-alertas/$alertaId'
    | '/$perfil/projetos/$projetoId'
    | '/$perfil/regras/$codigo'
    | '/$perfil/times/$timeId'
    | '/$perfil/frango'
    | '/$perfil/mergeguard'
    | '/$perfil/meus-alertas'
    | '/$perfil/projetos'
    | '/$perfil/regras'
    | '/$perfil/times'
    | '/$perfil/frango/$projeto/$iid'
    | '/$perfil/frango/lote/$projeto/$iid'
  id:
    | '__root__'
    | '/'
    | '/$perfil'
    | '/chamado'
    | '/entrar'
    | '/$perfil/adesao-frango'
    | '/$perfil/alertas'
    | '/$perfil/configuracoes'
    | '/$perfil/entregas'
    | '/$perfil/erros'
    | '/$perfil/inicio'
    | '/$perfil/pessoas'
    | '/$perfil/qualidade'
    | '/$perfil/tarefas-paradas'
    | '/$perfil/uso-ia'
    | '/$perfil/visao-geral'
    | '/dev/componentes'
    | '/dev/tokens'
    | '/legado/$'
    | '/$perfil/'
    | '/$perfil/mergeguard/$configHash'
    | '/$perfil/meus-alertas/$alertaId'
    | '/$perfil/projetos/$projetoId'
    | '/$perfil/regras/$codigo'
    | '/$perfil/times/$timeId'
    | '/$perfil/frango/'
    | '/$perfil/mergeguard/'
    | '/$perfil/meus-alertas/'
    | '/$perfil/projetos/'
    | '/$perfil/regras/'
    | '/$perfil/times/'
    | '/$perfil/frango/$projeto/$iid'
    | '/$perfil/frango/lote/$projeto/$iid'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PerfilRouteRoute: typeof PerfilRouteRouteWithChildren
  ChamadoRoute: typeof ChamadoRoute
  EntrarRoute: typeof EntrarRoute
  DevComponentesRoute: typeof DevComponentesRoute
  DevTokensRoute: typeof DevTokensRoute
  LegadoSplatRoute: typeof LegadoSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$perfil': {
      id: '/$perfil'
      path: '/$perfil'
      fullPath: '/$perfil'
      preLoaderRoute: typeof PerfilRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chamado': {
      id: '/chamado'
      path: '/chamado'
      fullPath: '/chamado'
      preLoaderRoute: typeof ChamadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$perfil/': {
      id: '/$perfil/'
      path: '/'
      fullPath: '/$perfil/'
      preLoaderRoute: typeof PerfilIndexRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/adesao-frango': {
      id: '/$perfil/adesao-frango'
      path: '/adesao-frango'
      fullPath: '/$perfil/adesao-frango'
      preLoaderRoute: typeof PerfilAdesaoFrangoRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/alertas': {
      id: '/$perfil/alertas'
      path: '/alertas'
      fullPath: '/$perfil/alertas'
      preLoaderRoute: typeof PerfilAlertasRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/configuracoes': {
      id: '/$perfil/configuracoes'
      path: '/configuracoes'
      fullPath: '/$perfil/configuracoes'
      preLoaderRoute: typeof PerfilConfiguracoesRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/entregas': {
      id: '/$perfil/entregas'
      path: '/entregas'
      fullPath: '/$perfil/entregas'
      preLoaderRoute: typeof PerfilEntregasRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/erros': {
      id: '/$perfil/erros'
      path: '/erros'
      fullPath: '/$perfil/erros'
      preLoaderRoute: typeof PerfilErrosRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/inicio': {
      id: '/$perfil/inicio'
      path: '/inicio'
      fullPath: '/$perfil/inicio'
      preLoaderRoute: typeof PerfilInicioRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/pessoas': {
      id: '/$perfil/pessoas'
      path: '/pessoas'
      fullPath: '/$perfil/pessoas'
      preLoaderRoute: typeof PerfilPessoasRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/qualidade': {
      id: '/$perfil/qualidade'
      path: '/qualidade'
      fullPath: '/$perfil/qualidade'
      preLoaderRoute: typeof PerfilQualidadeRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/tarefas-paradas': {
      id: '/$perfil/tarefas-paradas'
      path: '/tarefas-paradas'
      fullPath: '/$perfil/tarefas-paradas'
      preLoaderRoute: typeof PerfilTarefasParadasRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/uso-ia': {
      id: '/$perfil/uso-ia'
      path: '/uso-ia'
      fullPath: '/$perfil/uso-ia'
      preLoaderRoute: typeof PerfilUsoIaRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/visao-geral': {
      id: '/$perfil/visao-geral'
      path: '/visao-geral'
      fullPath: '/$perfil/visao-geral'
      preLoaderRoute: typeof PerfilVisaoGeralRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/dev/componentes': {
      id: '/dev/componentes'
      path: '/dev/componentes'
      fullPath: '/dev/componentes'
      preLoaderRoute: typeof DevComponentesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/tokens': {
      id: '/dev/tokens'
      path: '/dev/tokens'
      fullPath: '/dev/tokens'
      preLoaderRoute: typeof DevTokensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legado/$': {
      id: '/legado/$'
      path: '/legado/$'
      fullPath: '/legado/$'
      preLoaderRoute: typeof LegadoSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$perfil/frango/': {
      id: '/$perfil/frango/'
      path: '/frango'
      fullPath: '/$perfil/frango/'
      preLoaderRoute: typeof PerfilFrangoIndexRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/mergeguard/': {
      id: '/$perfil/mergeguard/'
      path: '/mergeguard'
      fullPath: '/$perfil/mergeguard/'
      preLoaderRoute: typeof PerfilMergeguardIndexRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/mergeguard/$configHash': {
      id: '/$perfil/mergeguard/$configHash'
      path: '/mergeguard/$configHash'
      fullPath: '/$perfil/mergeguard/$configHash'
      preLoaderRoute: typeof PerfilMergeguardConfigHashRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/meus-alertas/': {
      id: '/$perfil/meus-alertas/'
      path: '/meus-alertas'
      fullPath: '/$perfil/meus-alertas/'
      preLoaderRoute: typeof PerfilMeusAlertasIndexRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/meus-alertas/$alertaId': {
      id: '/$perfil/meus-alertas/$alertaId'
      path: '/meus-alertas/$alertaId'
      fullPath: '/$perfil/meus-alertas/$alertaId'
      preLoaderRoute: typeof PerfilMeusAlertasAlertaIdRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/projetos/': {
      id: '/$perfil/projetos/'
      path: '/projetos'
      fullPath: '/$perfil/projetos/'
      preLoaderRoute: typeof PerfilProjetosIndexRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/projetos/$projetoId': {
      id: '/$perfil/projetos/$projetoId'
      path: '/projetos/$projetoId'
      fullPath: '/$perfil/projetos/$projetoId'
      preLoaderRoute: typeof PerfilProjetosProjetoIdRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/regras/': {
      id: '/$perfil/regras/'
      path: '/regras'
      fullPath: '/$perfil/regras/'
      preLoaderRoute: typeof PerfilRegrasIndexRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/regras/$codigo': {
      id: '/$perfil/regras/$codigo'
      path: '/regras/$codigo'
      fullPath: '/$perfil/regras/$codigo'
      preLoaderRoute: typeof PerfilRegrasCodigoRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/times/': {
      id: '/$perfil/times/'
      path: '/times'
      fullPath: '/$perfil/times/'
      preLoaderRoute: typeof PerfilTimesIndexRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/times/$timeId': {
      id: '/$perfil/times/$timeId'
      path: '/times/$timeId'
      fullPath: '/$perfil/times/$timeId'
      preLoaderRoute: typeof PerfilTimesTimeIdRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/frango/$projeto/$iid': {
      id: '/$perfil/frango/$projeto/$iid'
      path: '/frango/$projeto/$iid'
      fullPath: '/$perfil/frango/$projeto/$iid'
      preLoaderRoute: typeof PerfilFrangoProjetoIidRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
    '/$perfil/frango/lote/$projeto/$iid': {
      id: '/$perfil/frango/lote/$projeto/$iid'
      path: '/frango/lote/$projeto/$iid'
      fullPath: '/$perfil/frango/lote/$projeto/$iid'
      preLoaderRoute: typeof PerfilFrangoLoteProjetoIidRouteImport
      parentRoute: typeof PerfilRouteRoute
    }
  }
}

interface PerfilRouteRouteChildren {
  PerfilAdesaoFrangoRoute: typeof PerfilAdesaoFrangoRoute
  PerfilAlertasRoute: typeof PerfilAlertasRoute
  PerfilConfiguracoesRoute: typeof PerfilConfiguracoesRoute
  PerfilEntregasRoute: typeof PerfilEntregasRoute
  PerfilErrosRoute: typeof PerfilErrosRoute
  PerfilInicioRoute: typeof PerfilInicioRoute
  PerfilPessoasRoute: typeof PerfilPessoasRoute
  PerfilQualidadeRoute: typeof PerfilQualidadeRoute
  PerfilTarefasParadasRoute: typeof PerfilTarefasParadasRoute
  PerfilUsoIaRoute: typeof PerfilUsoIaRoute
  PerfilVisaoGeralRoute: typeof PerfilVisaoGeralRoute
  PerfilIndexRoute: typeof PerfilIndexRoute
  PerfilMergeguardConfigHashRoute: typeof PerfilMergeguardConfigHashRoute
  PerfilMeusAlertasAlertaIdRoute: typeof PerfilMeusAlertasAlertaIdRoute
  PerfilProjetosProjetoIdRoute: typeof PerfilProjetosProjetoIdRoute
  PerfilRegrasCodigoRoute: typeof PerfilRegrasCodigoRoute
  PerfilTimesTimeIdRoute: typeof PerfilTimesTimeIdRoute
  PerfilFrangoIndexRoute: typeof PerfilFrangoIndexRoute
  PerfilMergeguardIndexRoute: typeof PerfilMergeguardIndexRoute
  PerfilMeusAlertasIndexRoute: typeof PerfilMeusAlertasIndexRoute
  PerfilProjetosIndexRoute: typeof PerfilProjetosIndexRoute
  PerfilRegrasIndexRoute: typeof PerfilRegrasIndexRoute
  PerfilTimesIndexRoute: typeof PerfilTimesIndexRoute
  PerfilFrangoProjetoIidRoute: typeof PerfilFrangoProjetoIidRoute
  PerfilFrangoLoteProjetoIidRoute: typeof PerfilFrangoLoteProjetoIidRoute
}

const PerfilRouteRouteChildren: PerfilRouteRouteChildren = {
  PerfilAdesaoFrangoRoute: PerfilAdesaoFrangoRoute,
  PerfilAlertasRoute: PerfilAlertasRoute,
  PerfilConfiguracoesRoute: PerfilConfiguracoesRoute,
  PerfilEntregasRoute: PerfilEntregasRoute,
  PerfilErrosRoute: PerfilErrosRoute,
  PerfilInicioRoute: PerfilInicioRoute,
  PerfilPessoasRoute: PerfilPessoasRoute,
  PerfilQualidadeRoute: PerfilQualidadeRoute,
  PerfilTarefasParadasRoute: PerfilTarefasParadasRoute,
  PerfilUsoIaRoute: PerfilUsoIaRoute,
  PerfilVisaoGeralRoute: PerfilVisaoGeralRoute,
  PerfilIndexRoute: PerfilIndexRoute,
  PerfilMergeguardConfigHashRoute: PerfilMergeguardConfigHashRoute,
  PerfilMeusAlertasAlertaIdRoute: PerfilMeusAlertasAlertaIdRoute,
  PerfilProjetosProjetoIdRoute: PerfilProjetosProjetoIdRoute,
  PerfilRegrasCodigoRoute: PerfilRegrasCodigoRoute,
  PerfilTimesTimeIdRoute: PerfilTimesTimeIdRoute,
  PerfilFrangoIndexRoute: PerfilFrangoIndexRoute,
  PerfilMergeguardIndexRoute: PerfilMergeguardIndexRoute,
  PerfilMeusAlertasIndexRoute: PerfilMeusAlertasIndexRoute,
  PerfilProjetosIndexRoute: PerfilProjetosIndexRoute,
  PerfilRegrasIndexRoute: PerfilRegrasIndexRoute,
  PerfilTimesIndexRoute: PerfilTimesIndexRoute,
  PerfilFrangoProjetoIidRoute: PerfilFrangoProjetoIidRoute,
  PerfilFrangoLoteProjetoIidRoute: PerfilFrangoLoteProjetoIidRoute,
}

const PerfilRouteRouteWithChildren = PerfilRouteRoute._addFileChildren(
  PerfilRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PerfilRouteRoute: PerfilRouteRouteWithChildren,
  ChamadoRoute: ChamadoRoute,
  EntrarRoute: EntrarRoute,
  DevComponentesRoute: DevComponentesRoute,
  DevTokensRoute: DevTokensRoute,
  LegadoSplatRoute: LegadoSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
